/**
 * Places - Single (detail view)
 */

'use strict';

var eventsArchive = require('../events/archive');
var GoogleMapsLoader = require('google-maps');
var cmGoogleMaps = require('../misc/googleMaps');
require('../misc/socialSharePopup');

// Constructor
var FrontPlacesSingle = function () {
    if (!$('body').hasClass('single-cm-places')) {
        return;
    }

    $(document).ready((function() {
        this.asideMobile();
        this.computeUiElementsPosition();
        this.limitNumberVisibleEvents();
    }).bind(this));

    this.initMasonryGallery();
    this.displayGoogleMaps();
};

FrontPlacesSingle.prototype = {
    /**
     * Compute the position and place the elements on the page.
     */
    computeUiElementsPosition: function() {
        // Position the share button and badge next to the title
        // NB: mandatory because of z-index problem with the clip-path

        var setBtnSharePosition = function () {
            var content = $('article#place .col-content .inner');
            var offset = content.offset().left + content.width();
            var titleHeight = $('article#place .col-content .entry-title').height();

            if ($(window).width() > 992) {
                offset = offset - 40;
            } else {
                offset = offset - 10;
                titleHeight = titleHeight - 10;
            }

            if (bowser.mobile) {
                offset = offset - 10;
                titleHeight = 70;
            }

            $('article#place .header-bottom .share-btn').css({
                'left': offset,
                'top': -titleHeight
            }).show();
        };

        var setBadgePartnerPosition = function() {
            var content = $('article#place .col-content .inner');
            var offset = content.offset().left;
            var bottom = '50px';

            if (bowser.mobile) {
                bottom = '30px';
            }

            if ($(window).width() <= 1420) {
                offset = '40px';
            }

            if (bowser.mobile) {
                offset = '30px';
            }

            $('article#place .header-bottom .badge').css({
                'bottom': bottom,
                'left': offset
            }).show();
        };

        $(window).resize(function () {
            setBtnSharePosition();
            setBadgePartnerPosition();
        });

        setBtnSharePosition();
        setBadgePartnerPosition();

        // Equal columns heights for entry-content and sidebar

        if ($(window).width() > 992) {
            $('article#place .wrapper > .col').matchHeight();
        }

        // Share popup

        $('article#place .share-btn a.popup').on("click", function(e) {
            $(this).socialSharePopup(e);
        });
    },

    /**
     * Initialize the masonry images gallery.
     */
    initMasonryGallery: function() {
        var $grid = $('article#place #images-gallery .masonry').imagesLoaded(function () {
            // Init Masonry after all images have loaded
            $grid.masonry({
                itemSelector: '.gallery-item',
                columnWidth: '.gallery-item',
                percentPosition: true,
            });
        });

        $('article#place #images-gallery .masonry').magnificPopup({
            delegate: '.gallery-item a',
            type: 'image',
            closeOnContentClick: false,
            closeBtnInside: false,
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
                titleSrc: function(item) {
                    return item.el.find('img').attr('data-caption');
                }
            },
            gallery: {
                enabled: true,
                preload: [0,2],
                navigateByImgClick: true,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                tPrev: comedien.i18n.galleryButtonPrev, // title for left button
                tNext: comedien.i18n.galleryButtonNext, // title for right button
                tCounter: '<span class="mfp-counter">%curr% '+ comedien.i18n.galleryCounter +' %total%</span>'
            },
            zoom: {
                enabled: true,
                duration: 300, // NB: also change the duration in CSS!
                opener: function(element) {
                    return element.find('img');
                }
            }
        });
    },

    /**
     * Display a Google Map from the place postal address.
     *
     * @param google Google API instance
     */
    displayGoogleMaps: function(google) {
        GoogleMapsLoader.KEY = cmGoogleMaps.apiKey;
        GoogleMapsLoader.LANGUAGE = 'fr';

        var googleMapsOptions = {
            center: {lat: 46.2, lng: 6.1667}, // Default: Geneva
            zoom: 17,
            styles: cmGoogleMaps.style,
            scrollwheel: false,
            navigationControl: true,
            mapTypeControl: false,
            scaleControl: true,
            draggable: true,
            disableDefaultUI: false,
            disableDoubleClickZoom: true,
        };

        GoogleMapsLoader.load(function(google) {
            var map = new google.maps.Map(document.getElementById('place-map'), googleMapsOptions);

            if (typeof cmPlace !== 'undefined' && cmPlace.address !== 'undefined' && cmPlace.address != ', ') {
                // Convert the place address into geographic coordinates with the Geocoding Service
                // and place a marker at the returned latitude and longitude values

                var geocoder = new google.maps.Geocoder();

                geocoder.geocode({'address': cmPlace.address}, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        // Recenter the map
                        map.setCenter(results[0].geometry.location);

                        // Place a marker

                        var pointAnchor = new google.maps.Point(285, 360);

                        var iconMarker = {
                            path: "M342,303c-0.41.61-.91,1.15-1.34,1.75l-7.34,8.52c-0.46.45-.87,1-1.34,1.39l-49.41,57.51-49.41-57.51c-0.62-.65-1.2-1.29-1.8-1.93l-6.52-7.57c-0.57-.71-1.14-1.42-1.7-2.16l-0.9-1.46A69.28,69.28,0,0,1,211,263.79c0-38.91,32-70.46,71.53-70.46s71.53,31.54,71.53,70.46a69.28,69.28,0,0,1-11.2,37.74Z",
                            fillColor: '#93775d',
                            fillOpacity: 1,
                            strokeWeight: 0,
                            scale: 0.3,
                            anchor: pointAnchor,
                        }

                        var iconBorder = {
                            path: "M282.54,375.16L223,306c-0.48-.6-1-1.21-1.44-1.84l-1-1.62a71.34,71.34,0,0,1-11.49-38.77c0-39.93,33-72.41,73.48-72.41S356,223.86,356,263.79a71.36,71.36,0,0,1-11.51,38.8l-0.93,1.51c-0.26.38-.55,0.74-0.83,1.09s-0.37.46-.54,0.7l-7.44,8.65c-0.28.29-.45,0.48-0.63,0.66s-0.56.6-.85,0.88Zm0-179.88C244.18,195.28,213,226,213,263.79a67.5,67.5,0,0,0,10.89,36.69l0.93,1.5,1.27,1.6,0.3,0.37,56.2,65.23,47.93-55.79c0.37-.37.58-0.6,0.8-0.83s0.42-.46.64-0.68l7.24-8.41c0.11-.16.33-0.44,0.56-0.72s0.43-.54.63-0.82l0.88-1.42a67.54,67.54,0,0,0,10.91-36.72C352.13,226,320.91,195.28,282.54,195.28Z",
                            fillColor: '#FFF',
                            fillOpacity: 1,
                            strokeWeight: 0,
                            scale: 0.3,
                            anchor: pointAnchor,
                        }

                        var iconShadow = {
                            url: comedien.assets + 'images/google-maps-marker-shadow.png',
                            size: new google.maps.Size(55, 20),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(12, 10)
                        }

                        var marker = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location,
                            title: cmPlace.name,
                            icon: iconMarker,
                            zIndex: 20
                        });

                        var markerBorder = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location,
                            icon: iconBorder,
                            zIndex: 30
                        });

                        var markerShadow = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location,
                            icon: iconShadow,
                            zIndex: 10
                        });
                    } else {
                        console.log("Geocode was not successful for the following reason: " + status);
                    }
                });
            }
        });
    },

    /**
     * Limit the number of visible events: on page load, display 3 events (one row).
     * Show a button to display more events.
     */
    limitNumberVisibleEvents: function() {
        var events = $('article#place .events .event');
        var btnMore = $('article#place .events .btn-more');

        if (events.length > 3) {
            btnMore.css('display', 'inline-block')

            /*var i = 0;
            events.each(function () {
                if (i > 2) {
                    $(this).hide();
                }
                i++;
            });*/
        }

        btnMore.on('click', function() {
            console.log('load more events');

            events.each(function () {
                if (!$(this).is(":visible")) {
                    $(this).fadeIn(200);
                }
            });

            btnMore.hide();

            // Recalculate the content wrapper height
            $.fn.matchHeight._maintainScroll = true;
            $.fn.matchHeight._update();
        });
    },

    asideMobile: function() {
        var html = $('article#place .col-right').html();
        $('article#place .col-aside-mobile').html(html);
    },
};

module.exports = new FrontPlacesSingle();
